export default "__VITE_ASSET__D2f7NJ$6__"